import { FC, useCallback } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { PendingInvitationMember } from '../types/members-types';
import { Avatar, Box, IconButton } from '@mui/material';
import { MdMoreVert as MoreVertIcon } from 'react-icons/md';
import RoleChips from './RoleChips';
import InvitationStatusChip from './InvitationStatusChip';
import {
  openResendInvitationModal,
  setSelectedRevokedInvitation,
} from '../store-actions/resend-invitation-store-actions';
import {
  openRevokeInvitationModal,
  setSelectedPendingInvitation,
} from '../store-actions/revoke-invitation-store-actions';
import {
  checkIsInvitationExpired,
  getInvitationExpirationLocalTime,
} from '../store-actions/invite-user-store-actions';

const PendingInviteTableRow: FC<
  React.PropsWithChildren<IPendingInviteTableRowProps>
> = ({ pendingInvitationMember, isMoreButtonDisabled }) => {
  const { inviteeEmail, expires_at } = pendingInvitationMember;

  const isInvitationExpired = checkIsInvitationExpired(expires_at);
  const invitationExpirationLocalTime =
    getInvitationExpirationLocalTime(expires_at);

  const handleClick = useCallback(() => {
    if (isMoreButtonDisabled || !pendingInvitationMember) {
      return;
    }
    if (isInvitationExpired) {
      setSelectedRevokedInvitation(pendingInvitationMember);
      openResendInvitationModal();
    } else {
      setSelectedPendingInvitation(pendingInvitationMember);
      openRevokeInvitationModal();
    }
  }, [isMoreButtonDisabled, pendingInvitationMember, isInvitationExpired]);

  return (
    <>
      <TableRow hover role='checkbox' tabIndex={-1}>
        <TableCell>
          <Box display='flex' alignItems='center' gap={2} ml={2}>
            <Avatar alt={inviteeEmail} />
            {inviteeEmail}
          </Box>
        </TableCell>
        <TableCell>{inviteeEmail}</TableCell>
        <TableCell>
          <RoleChips roles={[]} />
        </TableCell>
        <TableCell>
          <InvitationStatusChip
            isInvitationExpired={isInvitationExpired}
            invitationExpirationLocalTime={invitationExpirationLocalTime}
          />
        </TableCell>
        <TableCell onClick={handleClick}>
          <IconButton disabled={isMoreButtonDisabled}>
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};

export interface IPendingInviteTableRowProps {
  pendingInvitationMember: PendingInvitationMember;
  isMoreButtonDisabled: boolean;
}

export default PendingInviteTableRow;
